import { useMemo } from 'react';

import { PremiseOnSinglePremise } from '../../premises/Premise';
import { useDeleteTpOutletPhoto } from './useDeleteTpOutletPhotos';
import { useMutateTpOutletPhoto } from './useMutateTpOutletPhoto';
import { useConnection } from '../../connection/hooks/useConnection';

export const usePremiseTPOutlets = (premise: null | PremiseOnSinglePremise) => {
  const propertyId = useMemo(() => {
    return premise?.propertyId ?? null;
  }, [premise]);

  const {
    premiseTPOutlets,
    isError: isErrorTPOutlets,
    isLoading: isLoadingTPOutlets,
    isRefetching,
  } = useConnection(propertyId);

  const {
    deletePhoto,
    isSuccess: isSuccessDeletePhoto,
    isLoading: isDeletingPhoto,
  } = useDeleteTpOutletPhoto(propertyId);

  // Use offline-aware mutation hook
  const { mutate } = useMutateTpOutletPhoto(propertyId);

  const thisPremiseTPOutlets = useMemo(
    () =>
      premise ? premiseTPOutlets.filter(({ premiseId }) => premiseId !== undefined && premiseId === premise.id) : [],
    [premiseTPOutlets, isRefetching, premise?.id],
  );

  const updateTPOutletPhoto = (tpOutletId: string, photoUrl: string) => {
    if (propertyId === null) return;
    mutate({
      propertyId,
      tpOutletId,
      photoUrl,
    });
  };

  return {
    isLoadingTPOutlets,
    isErrorTPOutlets,
    tpOutlets: thisPremiseTPOutlets,
    updateTPOutletPhoto,
    deletePhoto,
    isSuccessDeletePhoto,
    isDeletingPhoto,
  };
};
